import React from 'react';
import { useNavbar } from '../../../../hooks/useNavbar';
import { NavIcon } from './NavIcon';

import styles from './style.module.scss';

export const Navicon = () => {
  const { toggle } = useNavbar();

  return (
    <button className={styles.navIcon} onClick={toggle}>
      <NavIcon />
    </button>
  );
};
